import themes from "daisyui/src/theming/themes";
import { ConfigProps } from "./types/config";

const config = {
  // REQUIRED
  appName: "ChangeLyric",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription:
    "The easiest unmoderated lyric swapping tool. Change any lyrics without restrictions. Purpose-built for creators who need freedom and precision.",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "changelyric.com",
  crisp: {
    // Crisp website ID. IF YOU DON'T USE CRISP: just remove this => Then add a support email in this config file (resend.supportEmail) otherwise customer support won't work.
    id: "",
    // Hide Crisp by default, except on route "/". Crisp is toggled with <ButtonSupport/>. If you want to show Crisp on every routes, just remove this below
    onlyShowOnRoutes: ["/"],
  },
  stripe: {
    // Create multiple plans in your Stripe dashboard, then add them here. You can add as many plans as you want, just make sure to add the priceId
    plans: [
      {
        // REQUIRED — we use this to find the plan in the webhook (for instance if you want to update the user's credits based on the plan)
        priceId:
          process.env.NODE_ENV === "development"
            ? "price_1Rg7R0DuuzxaZJYmvxWW9jYd"
            : "price_1Rg7R0DuuzxaZJYmvxWW9jYd",
        //  REQUIRED - Name of the plan, displayed on the pricing page
        name: "Starter",
        // A friendly description of the plan, displayed on the pricing page. Tip: explain why this plan and not others
        description: "Perfect for pro music producers",
        // The price you want to display, the one user will be charged on Stripe.
        price: 9,
        // If you have an anchor price (i.e. $29) that you want to display crossed out, put it here. Otherwise, leave it empty
        priceAnchor: 15,
        // Monthly generation limit (lyric swaps)
        lyricSwapLimit: 150,
        features: [
          {
            name: "150 credits per month",
          },

          { name: "Matches original vocal tone and melodies" },
          { name: "Vocal Isolator + Lead/Backing Splitter + Voice Changer" },
          { name: "DAW-ready vocal stem output" },
          { name: "No content restrictions" },
          { name: "30-day project retention" }
        ],
      },
      {
        priceId: "price_1SyFY1DuuzxaZJYmUWniV2Qh",
        name: "Pro",
        description: "For V3 power users",
        price: 49,
        priceAnchor: 69,
        lyricSwapLimit: 1000,
        features: [
          { name: "1,000 credits per month" },
          { name: "Everything in Starter" },
          { name: "90-day project retention" },
          { name: "Priority support" },
        ],
      },
    ],
    creditPacks: [
      {
        priceId: "price_1TvFTHDuuzxaZJYmtF0xLRwI",
        name: "200 Credit Top-Up",
        credits: 200,
        price: 10,
      },
    ],
  },
  aws: {
    // If you use AWS S3/Cloudfront, put values in here
    bucket: "bucket-name",
    bucketUrl: `https://bucket-name.s3.amazonaws.com/`,
    cdn: "https://cdn-id.cloudfront.net/",
  },
  resend: {
    // REQUIRED — Email 'From' field to be used when sending magic login links
    fromNoReply: `ChangeLyric <noreply@updates.changelyric.com>`,
    // REQUIRED — Email 'From' field to be used when sending other emails, like abandoned carts, updates etc..
    fromAdmin: `ChangeLyric <contact@updates.changelyric.com>`,
    // Email shown to customer if need support. Leave empty if not needed => if empty, set up Crisp above, otherwise you won't be able to offer customer support."
    supportEmail: "contact@changelyric.com",
  },
  colors: {
    // REQUIRED — The DaisyUI theme to use (added to the main layout.js). Leave blank for default (light & dark mode). If you any other theme than light/dark, you need to add it in config.tailwind.js in daisyui.themes.
    theme: "",
    // REQUIRED — This color will be reflected on the whole app outside of the document (loading bar, Chrome tabs, etc..). By default it takes the primary color from your DaisyUI theme (make sure to update your the theme name after "data-theme=")
    // OR you can just do this to use a custom color: main: "#f37055". HEX only.
    main: themes["light"]["primary"],
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/signin",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/dashboard",
  },
} as ConfigProps;

export default config;
